export default "__VITE_ASSET__CxyuBHVD__"